import React from "react";
import { Link } from "react-router-dom";

const SingleCabin = ({ image, name, size, price, ticks, features }) => {
  console.log("dataaaaa: ", image, name, size, price, ticks, features);

  return (
    <div className="bg-[#fafafa] p-10">
      <div className="flex flex-col md:flex-row  ">
        <div className="md:flex-1 ">
          <img src={image} alt="Tiny House" className="w-full h-[100%]" />
        </div>
        <div className="md:flex-1 space-y-4 p-5">
          <h1 className="text-2xl font-bold">{name}</h1>
          <p>
            {size} | {price}
          </p>
          <ul className="flex flex-col gap-4">
            {ticks.map((tick, index) => (
              <li className="flex items-center text-sm">
                <img
                  src="https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56dd_circle-check-transparent.png"
                  alt="Check"
                  className="w-4 h-4 mr-2"
                />
                {tick.name}
              </li>
            ))}
          </ul>

          <div className="w-full md:w-[500px] grid grid-cols-3 md:grid-cols-4 gap-5 md:gap-1 py-5">
            {features.map((feature, index) => (
              <div key={index} className="text-center py-0 md:py-2">
                <img src={feature.icon} alt="" className={`mx-auto ${feature.sizeSmall ? 'w-[64px] py-[12px] px-[12px] bg-[#f3f4f6] rounded-full' : 'w-[64px]'}`} />
                <p className="text-[#121212] font-medium text-xs">
                  {feature.text}
                </p>
              </div>
            ))}
          </div>

          <Link to="/locations/nyc"><button className="bg-black text-white rounded-full px-8 lg:px-16 py-2 mt-4 shadow hover:bg-gray-800 transition duration-300 w-full md:w-auto">
            Stay
          </button></Link>
        </div>
      </div>
    </div>
  );
};

export default SingleCabin;
